import { Fragment, useEffect, useRef } from "react";

import MainButton from "~/components/common/mainButton";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";

import styles from "./index.module.scss";

type Props = {
  currentStep: number;
};

const stepScroll: number[] = [0, 80, 210, 350, 500];

const getHighlightedStep = (currentStep: number) => {
  switch (currentStep) {
    case 1:
    case 2:
    case 3:
      return 0;
    case 4:
      return 1;
    case 5:
    case 6:
      return 2;
    case 7:
    case 8:
      return 3;
    case 9:
      return 4;
  }
  return -1;
};

const ApplicationNextStep = ({ currentStep }: Props) => {
  const { language } = useLanguage();
  const applyTexts =
    language === "En"
      ? englishTranslations.applyPage
      : frenchTranslations.applyPage;
  if (currentStep < 1 || currentStep > 9) return null;

  const containerRef = useRef<HTMLDivElement>(null);

  const steps: string[] = [
    applyTexts.applicationForm.personalInformation,
    "Photo de Profil",
    "À Propos de vous",
    "Membership",
    "payment",
  ];

  useEffect(() => {
    const container = containerRef.current;
    if (!!container) {
      container.scroll({
        left: stepScroll[getHighlightedStep(currentStep)],
        behavior: "smooth",
      });
    }
  }, [currentStep]);

  return (
    <div
      className={`${styles.applicationNextStep} no-scrollbar`}
      ref={containerRef}
    >
      {steps.map((step, i) => {
        const theme =
          getHighlightedStep(currentStep) == i ? "black" : "transparent-grey";
        return (
          <Fragment key={i}>
            <MainButton
              uiOnly
              theme={theme}
              onClick={(e) => {
                e.preventDefault();
              }}
              className={styles.stepButton}
            >
              {i + 1}. {step}
            </MainButton>{" "}
            {i !== 4 && "→"}
          </Fragment>
        );
      })}
    </div>
  );
};

export default ApplicationNextStep;
